










































































import { Vue, Component, Emit } from 'vue-property-decorator'
import ServerError from '@/utils/server_error'
// @ts-ignore
import { MazPhoneNumberInput } from 'maz-ui'
import { IdentityAPI } from '@/api/identity'
import sharedStore from '@/modules/shared/shared.store'
import { getModule } from 'vuex-module-decorators'

export interface PhoneNumberUpdatePayload {
  countryCode: string
  isValid: boolean
  countryCallingCode?: string
  nationalNumber?: string
  formatInternational?: string
  formatNational?: string
  uri?: string
  e164?: string
}

@Component({
  components: {
    MazPhoneNumberInput
  }
})
export default class PhoneNumberVerification extends Vue {
  sharedModule = getModule(sharedStore, this.$store)

  isLoading: boolean = false
  // isShowCountrySelector: boolean = true
  isMobile: boolean = false
  phoneNumber: string = ''
  results: PhoneNumberUpdatePayload | null = null
  // mql: MediaQueryList = matchMedia('(min-width: 600px)')
  code: string = 'TW' // WIP: use suggested region

  mounted() {
    // this.isShowCountrySelector = this.mql.matches
    // this.mql.addEventListener('change', this.checkScreenWidth)
  }

  destroyed() {
    // this.mql.removeEventListener('change', this.checkScreenWidth)
  }

  /* checkScreenWidth(e: MediaQueryListEvent) {
    this.isShowCountrySelector = e.matches
  } */

  @Emit('confirm')
  confirm() {
    return this.phoneNumber
  }

  onPhoneNumberUpdated(event: PhoneNumberUpdatePayload) {
    this.results = event
    this.code = event.countryCode
  }
  /* Methods */
  async onConfirm() {
    this.isLoading = true
    try {
      if (!this.results || !this.results.isValid) {
        this.$toast.error(this.$t('PhoneNumberVerification.InvalidPhoneNumber'))
        return
      } else {
        const verifyResult = await IdentityAPI.addAccountPhoneNumber({
          phoneNumber: this.phoneNumber
        })
        if (verifyResult.status === 200) this.confirm()
        else this.$toast.error(this.$t('PhoneNumberVerification.Failure'))
      }
    } catch (err) {
      this.$toast.error(this.$t('PhoneNumberVerification.Failure'))
      console.error(err)
    } finally {
      this.isLoading = false
    }
  }

  get countryList() {
    return this.sharedModule.applicationRegions
  }

  get countryCodeList() {
    return this.countryList.map(ri => ri.code)
  }

  get countryListVSelect() {
    return this.countryList.map(ri => ({
      value: ri.code,
      text: `${ri.name} (${ri.idd})`
    }))
  }
}
